import assetPath from '/app/packages/lebenslauf/articles/src/assets/tipps-bewerbungsschreiben.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')